import React from 'react';
import StarIcon from '@mui/icons-material/Star';
export function SocialProofStrip() {
  return <div className="bg-brand-purple text-white py-3 px-4" data-id="element-283">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 md:gap-6 text-center md:text-left" data-id="element-284">
        <div className="flex items-center gap-4" data-id="element-285">
          <div className="flex text-yellow-400" data-id="element-286">
            <StarIcon data-id="element-287" />
            <StarIcon data-id="element-288" />
            <StarIcon data-id="element-289" />
            <StarIcon data-id="element-290" />
            <StarIcon data-id="element-291" />
          </div>
          <div data-id="element-292">
            <p className="font-bold text-lg" data-id="element-293">4.9/5 calificación promedio</p>
          </div>
        </div>

        <div className="text-center" data-id="element-294">
          <p className="font-bold text-xl tracking-wide" data-id="element-295">
            +500 PERSONAS YA EMPEZARON
          </p>
          <p className="text-brand-cream/80 text-sm" data-id="element-296">
            A crear arte con sus propias manos
          </p>
        </div>

        <div className="flex gap-6 text-sm font-medium" data-id="element-297">
          <div className="flex items-center gap-2" data-id="element-298">
            <span className="text-2xl" data-id="element-299">📘</span>
            <span data-id="element-300">
              2 tomos
              <br data-id="element-301" />
              completos
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-302">
            <span className="text-2xl" data-id="element-303">🎁</span>
            <span data-id="element-304">
              4 bonos
              <br data-id="element-305" />
              incluidos
            </span>
          </div>
        </div>
      </div>
    </div>;
}